import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { inputStyles } from './styles';

const Input = ({
    hostedFieldsInstance,
    id,
    onBlur,
    onFocus,
    className,
    classes,
}) => {
    useEffect(() => {
        if (hostedFieldsInstance) {
            const field = id.split('braintree-')[1];
            hostedFieldsInstance.on('blur', (event) => {
                if (event.emittedBy === field) {
                    onBlur();
                }
            });

            hostedFieldsInstance.on('focus', (event) => {
                if (event.emittedBy === field) {
                    onFocus();
                }
            });
        }
    }, [hostedFieldsInstance, id, onBlur, onFocus]);

    return (
        <div className={classNames(className, classes.root)} id={id} data-testid={id} />
    );
};

Input.propTypes = {
    hostedFieldsInstance: PropTypes.object,
    id: PropTypes.string.isRequired,
    onBlur: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    className: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
};

export { Input as InputAlias };

export default withStyles(inputStyles)(Input);
